import { IApplicationFormStep } from '../../types';
import { JsonInput } from 'components/UI/JsonForm/JsonInputRenderer/types';
import { States } from '../../../../constants';

const programEligibility: JsonInput[] = [
  {
    type: 'input',
    gridColSpan: 'col-span-12',
    props: {
      name: 'programEligibility.address',
      label: 'Address',
    },
  },
  {
    type: 'input',
    gridColSpan: 'col-span-4',
    props: {
      name: 'programEligibility.city',
      label: 'City',
      disabled: true,
    },
    defaultValue: 'Birmingham',
  },
  {
    type: 'select',
    gridColSpan: 'col-span-4',
    props: {
      name: 'programEligibility.state',
      label: 'State',
      options: States.map((state) => ({
        label: state.name,
        value: state.name,
      })),
      disabled: true,
    },
    defaultValue: 'Alabama',
  },
  {
    type: 'masked',
    gridColSpan: 'col-span-4',
    props: {
      name: 'programEligibility.zipCode',
      label: 'Zip / Postal Code',
      maskedComponent: 'zipCode',
    },
  },
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'programEligibility.q1',
      label: 'Do you own the property ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'programEligibility.q2',
      label: 'Do you occupy the property ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'input',
    props: {
      name: 'programEligibility.householdSize',
      label: 'Household Size',
    },
  },
  {
    type: 'masked',
    props: {
      name: 'programEligibility.householdIncome',
      label: 'Household Income',
      maskedComponent: 'currency',
    },
  },
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'programEligibility.q3',
      label: 'Are you current on property taxes ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
];

const demographics: JsonInput[] = [
  {
    type: 'checkbox-group',
    props: {
      name: 'demographics.ethnicity',
      label: 'Race or Ethnicity (check all that apply)',
      orientation: 'vertical',
      options: [
        {
          label: 'American Indian or Alaska Native',
          value: 'American Indian or Alaska Native',
        },
        {
          label: 'Asian',
          value: 'Asian',
        },
        {
          label: 'Black or African American',
          value: 'Black or African American',
        },
        {
          label: 'Hispanic or Latino',
          value: 'Hispanic or Latino',
        },
        {
          label: 'Native Hawaiian or Other Pacific Islander',
          value: 'Native Hawaiian or Other Pacific Islander',
        },
        {
          label: 'White',
          value: 'White',
        },
      ],
    },
  },
  {
    type: 'checkbox-group',
    props: {
      name: 'demographics.householdHead',
      label: 'Head of Household (check all that apply)',
      orientation: 'vertical',
      options: [
        {
          label: 'Female',
          value: 'Female',
        },
        {
          label: 'Elderly',
          value: 'Elderly',
        },
        {
          label: 'Disabled',
          value: 'Disabled',
        },
      ],
    },
  },
];

const requestedRepairs: JsonInput[] = [
  {
    type: 'checkbox-group',
    props: {
      name: 'requestedRepairs.options',
      label: 'Repairs Requested (check all that apply)',
      orientation: 'vertical',
      options: [
        {
          label: 'Roof Replacement',
          value: 'Roof Replacement',
        },
        {
          label: 'HVAC Repair or Replacement',
          value: 'HVAC Repair or Replacement',
        },
        {
          label: 'Plumbing Repairs',
          value: 'Plumbing Repairs',
        },
        {
          label: 'Electrical Repairs',
          value: 'Electrical Repairs',
        },
        {
          label: 'Sewer Repairs (limited)',
          value: 'Sewer Repairs (limited)',
        },
        {
          label: 'Structural Repairs (limited)',
          value: 'Structural Repairs (limited)',
        },
        {
          label: 'Exterior Painting',
          value: 'Exterior Painting',
        },
      ],
    },
  },
];

export const CRP2022Steps: IApplicationFormStep[] = [
  {
    title: 'Program Eligibility',
    sections: [
      {
        id: 'programEligibility',
        title: 'Program Eligibility',
        subTitle:
          'Please provide information to determine eligibility for the program.',
        inputs: programEligibility,
      },
    ],
  },
  {
    title: 'Demographics',
    sections: [
      {
        id: 'demographics',
        title: 'Demographics',
        subTitle: 'Please provide information about the demographics',
        inputs: demographics,
      },
    ],
  },
  {
    title: 'Repairs Requested',
    sections: [
      {
        id: 'repairsRequested',
        title: 'Repairs Requested',
        subTitle: 'Please provide information about your requested repairs.',
        inputs: requestedRepairs,
      },
    ],
  },
];
